import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { CallIvrMenusState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: CallIvrMenusState = {
    ivrMenus: [],
};


export const callIvrMenus: Module<CallIvrMenusState,RootState> = {
    state,
    getters,
    actions,
    mutations
};
